
import CustomLayout from "../CustomLayout/CustomLayout";
import styles from "./Image.module.scss";

export default function Image(props: any) {
  
  return (
    <CustomLayout>
      <div className={styles["container-image"]}>
        <img src={props.url} alt="" srcSet="" />
      </div>
    </CustomLayout>
  )
}
